// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aj5s","delete":"styles_delete__381ue","update":"styles_update__GlIl4","add":"styles_add__2AlCM"};